import { render, staticRenderFns } from "./ProvisionCategoryCreationModal.vue?vue&type=template&id=5b357a46&"
import script from "./ProvisionCategoryCreationModal.vue?vue&type=script&lang=js&"
export * from "./ProvisionCategoryCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports